import {config} from '../config'

export const isMobileDevice = (): boolean | undefined => config.isMobile
